export default __webpack_public_path__ + "static/media/boxClever2.9ace5092.png";